import * as React from "react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthCard, SecondFactorForm } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";

/**
 * Second login step for users with 2FA: the password session (aal1) has to
 * pass a second factor before the app (and every tRPC call) works.
 */
export function VerifyLoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  const { user, loading, aal, needsSecondFactor, signOut } = useAuth();

  React.useEffect(() => {
    if (loading) return;
    if (!user) void navigate({ to: "/login" });
    else if (aal && !needsSecondFactor) void navigate({ to: "/app" });
  }, [loading, user, aal, needsSecondFactor, navigate]);

  return (
    <AuthCard
      title={t("mfa.verifyTitle")}
      description={t("mfa.verifySubtitle")}
      footer={
        <button
          type="button"
          className="font-medium text-primary hover:underline"
          onClick={async () => {
            await signOut();
            void navigate({ to: "/login" });
          }}
        >
          {t("mfa.signOut")}
        </button>
      }
    >
      {needsSecondFactor ? (
        <SecondFactorForm onVerified={() => void navigate({ to: "/app" })} />
      ) : null}
    </AuthCard>
  );
}

export default VerifyLoginPage;
